import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`職涯從傳統產業開始，在傳統產業七年的時間裡，擔任過 ISO 9002 內稽人員，以及產品研發主管，在工作上發現很多使用者操作上的問題，於是回到校園攻讀認知科學碩士，建立對於人的了解，之後回到業界進入了用戶體驗領域。`}</p>
    <p>{`專長在使用者研究、服務設計、通用設計、產業生態系規劃、循環經濟以及產業輔導，合作過的產業別從交通、醫療、餐飲、金融保險、以及科技元件產業，一直從人的生活為出發點，協助客戶優化服務內容，挖掘創新需求。`}</p>
    <p>{`部落格: `}<a parentName="p" {...{
        "href": "https://medium.com/@nor.chen"
      }}>{`https://medium.com/@nor.chen`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      